import React from 'react'
import { Form } from 'react-bootstrap'
import Colors from 'utils/colors'

const CheckboxWithText = ({ textOne, textTwo, onChange, checked }) => {
  return (
    <Form className='pb-3'>
      <Form.Check
        type="checkbox"
        id="custom-radio"
        name="example-radio"
        label={
          <div>
            <p style={styles.text}>{textOne}</p>
            <a
              style={{ textDecorationColor: '#FFF' }}
              href="https://yelmo-paris.s3.eu-west-3.amazonaws.com/temp/politicas_yelmo.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p style={styles.text2}>{textTwo}</p>
            </a>
          </div>
        }
        onChange={onChange}
        checked={checked}
      />
    </Form>
  )
}

const styles = {
  text: {
    color: Colors.white,
    fontFamily: 'TTNormsRegular',
    fontSize: '12px',
    textAlign: 'justify',
    margin: 0,
  },
  text2: {
    color: Colors.white,
    fontFamily: 'TTNormsRegular',
    fontSize: '12px',
    textAlign: 'justify',
    paddingTop: 10,
    margin: 0,
  },
}

export default CheckboxWithText
